export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const RESTORE_PREV_SIDEBAR_STATE = 'RESTORE_PREV_SIDEBAR_STATE';
